import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';

import ClientInvoiceSearchModal from './ClientInvoiceSearchModal';

export type ClientInvoiceSelectedType = {
  ciid?: number;
  cireference?: string;
  clientname?: string;
};

export type ClientInvoiceSelectProps = {
  onChange?: any;
  onSelected?: (value: ClientInvoiceSelectedType) => void;
  value?: ClientInvoiceSelectedType|any;
  clear?: any;
  onlyCiid?: boolean;
  ctref?:string
};

const ClientInvoiceSelect = ({
  ctref,
  onChange = noop,
  onSelected,
  value,
  clear,
  onlyCiid,
}: ClientInvoiceSelectProps) => {
  const [Params, setParams] = useState<ClientInvoiceSelectedType>({
    ciid: value?.ciid,
    cireference: value?.cireference,
    clientname: value?.clientname,
  });

  const { visible, close, open } = useModalState(false);
  const handleSelect = (item: any) => {
    onlyCiid ? onChange(item.ciid) : onChange(item);

    setParams({
      cireference: item?.cireference,
      clientname: item.clientname,
      ciid: item?.ciid,
    });
    if (onSelected)
        onSelected({
          cireference: item?.cireference,
      clientname: item.clientname,
      ciid: item?.ciid,
        });
    close();
  };

  useEffect(() => {
    setParams({
      ciid: undefined,
      cireference: undefined,
      clientname: undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    value = undefined;
  }, [clear]);

  return (
    <>
      <AppSearchInput
        onSearch={() => {
          open();
          localStorage.removeItem('searchParams');
          localStorage.removeItem('searchParams_components');
        }}
        value={
          <Typography.Link>
            {!value?.ciid
              ? Params?.ciid && value !== 0 && value !== ''&& !isNil(value)
                ? `${Params.cireference ?? ''}  -  ${Params.clientname ?? ''}`
                : 'Select an Invoice'
              : value?.ciid && value !== 0 && value !== ''&& !isNil(value)
              ? `${value.cireference ?? ''}  -  ${value.clientname ?? ''}`
              : 'Select an invoice'}
          </Typography.Link>
        }
      />
      <ClientInvoiceSearchModal
        visible={visible}
        onCancel={close}
        setClientInvoice={handleSelect}
        ctref={ctref}
      />
    </>
  );
};

export default ClientInvoiceSelect;
